module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', {
    staticClass: "box2"
  }, [_vm._v("2.1")]), _vm._v(" REGIONAL REVIEW")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('h2', {
    staticClass: "ch-right"
  }, [_c('span', {
    staticClass: "box4"
  }, [_vm._v("Author: Conrad Waters")])]), _vm._v(" "), _c('h2', {
    staticClass: "ch-title",
    attrs: {
      "id": "ch2_1"
    }
  }, [_vm._v("NORTH AND SOUTH AMERICA")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he advent of a new United States president has essentially confirmed that the large increases in military spending that were already starting to run out of steam as the Trump presidency came to an end are now definitively over. The FY2022 National Defense Budget Request released on 29 May 2021 amounted to US$752.9bn. This is a nominal 1.6 percent increase on the previous year’s US$740.7bn but broadly flat overall in real terms. The Department of the Navy’s allocation was US$211.7bn compared with last year’s US$208bn, representing a similar level of growth. With some, more radical Democrat Members of Congress already seeking a more dramatic curtailment to military largesse, the navy will likely need to live within its existing funding envelope for the foreseeable future."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_1",
      "id": "fn2_1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What is less certain at the current time is how the US Navy will distribute the resources it has been allocated in an era when the challenges it faces are the greatest for many decades. Some choices seem to be clearer than others. The Global Posture Review that is currently underway has already been mandated to prioritise the growing threats from China and Russia over operations in more peripheral areas. It also seems likely from detailed budget breakdowns that fleet readiness and, particularly, longerterm research and development will be favoured over immediate procurement. These decisions seem to be rational given the large investments that will be required if the new networked and autonomous technologies that support operational concepts such as distributed maritime operations (DMO) are going to work effectively. DMO, alongside the US Marine Corps’ new Littoral Operations in a Contested Environment and Expeditionary Advanced Base Operations concepts, was at the centre of the new tri-naval service "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Advantage at Sea")]), _vm._v(" strategy published in the dying days of the Trump administration in December 2020."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_2",
      "id": "fn2_2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is greater doubt as to what structure the future US Navy should take. In December 2016, the navy released the results of a Force Structure Assessment (FSA) setting a goal for a 355-strong ‘battleforce’, a target that compares with fewer than 300 ships currently in service. Work has been undergoing since 2019 to update this target in view of the changing strategic situation and evolving technologies, particularly in the unmanned sphere. The general direction of travel has been a vision of a fleet with a smaller proportion of large ships, greater numbers of small ships and a new component of unmanned vessels to support the DMO strategy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, precisely how this analysis will translate into the fleet’s constituent numbers remains under consideration. The latest update to Congress on long-range shipbuilding plans – the first issued by the Biden administration – is a holding document, setting broad force parameters that will not be fully refined until next year’s budget cycle. In general terms, the new report seems to reflect budgetary realities by ‘rowing back’ on plans for expansion of the manned fleet whilst continuing to seek a large fleet of unmanned ships, albeit smaller than sometimes envisaged. However, the overall fleet is still targeted to be larger and, thus, more expensive than hitherto. This raises questions as to how such a navy is going to be built and maintained, particularly given the US Navy’s long history of struggling to grow ship numbers."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_3",
      "id": "fn2_3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another question is how to reverse the lacklustre results of recent US Navy warship procurement. The most significant surface combatant class – the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke")]), _vm._v(" (DDG-51) destroyers – trace their origins to the Cold War. Subsequent ships – the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumwalt")]), _vm._v(" (DDG-1000) class destroyers and Littoral Combat Ships – have been design dead ends into which vast sums have been poured for modest tangible results. A shocking element of the latest budget is a proposal to retire the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom")]), _vm._v(" (LCS-1) variant ships "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Detroit")]), _vm._v(" (LCS-7) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Little Rock")]), _vm._v(" (LCS- 9), fewer than five years after they entered service. A defect in the class’s combining gearing that connects the ships’ gas turbines and diesels with their waterjets has resulted in the navy refusing to accept further deliveries until the problem is resolved. It also appears it has determined that the cost of fixing the problem in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Detroit")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Little Rock")]), _vm._v(" is not worth the effort. Combined with the previous decision to retire the first four, prototype littoral combat ships due to a non-standard configuration, the navy will have written off six members of a class that was, until recently, supposed to be a mainstay of the future fleet. It can only be hoped that the US Navy can learn lessons from these past programmes as it stands up the program office for its next surface combatant, the DDG(X) guided missile destroyer.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg13_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("The US Navy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke")]), _vm._v(" class destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barry")]), _vm._v(" (DDG-52) conducts a replenishment exercise with the amphibious assault ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("America")]), _vm._v(" (LHA-6) on 15 October 2020. The US Navy is struggling to determine the right mix of large ships such as these in its future force mix as it restructures to face ever-strengthening Chinese naval power. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Navy)")])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('div', {
    staticClass: "img_container1a",
    attrs: {
      "id": "tab_2_1a"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg13_b.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Note:")])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1a"
    }
  }, [_vm._v("1")]), _vm._v(". Argentina’s two remaining submarines are non-operational and unlikely to be returned to service. A number of other Argentinian and Brazilian vessels are of uncertain operational status.")])]), _vm._v(" "), _c('h3', {
    staticClass: "ch-sub"
  }, [_vm._v("MAJOR NORTH AMERICAN NAVIES – CANADA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("The most significant event to benefit the Royal Canadian Navy (RCN) in the past year has been the formal commissioning of the lead "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harry DeWolf")]), _vm._v(" class Arctic and offshore patrol vessel at a ceremony at Halifax on 26 June 2021. The ship was delivered by Irving Shipbuilding’s Halifax yard at the end of July 2020 and has subsequently completed an extensive series of post-acceptance trials and training. Her arrival in the operational fleet provides the navy with the first tangible fruits of the Canadian National Shipbuilding Strategy (NSS) announced as far back as 2010. Five other ships of the class will be completed for RCN service over the next few years followed by two slightly modified vessels for the Canadian Coast Guard. The second ship of the class, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Margaret Brook")]), _vm._v(", is currently undergoing trials whilst 2021 has also seen the keel laying for the fourth unit, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("William Hall")]), _vm._v(", on 17 February as well as the first steel cutting for the fifth vessel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frédérick Rolette")]), _vm._v(", on 20 May.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg14_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The new lead Royal Canadian Navy Arctic and Offshore Patrol Ship (AOPS) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harry DeWolf")]), _vm._v(" seen in the course of postacceptance trials in company with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kingston")]), _vm._v(" class coastal defence vessel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Summerside. Harry DeWolf")]), _vm._v(" was formally commissioned on 26 June 2021. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Canadian Armed Forces)")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("The next project allocated to Irving’s Halifax facility under the NSS is the new Canadian Surface Combatant. The design effort for the new ship is being led by Lockheed Martin Canada (LMC) and uses the BAE Systems Type 26 Global Combat Ship as its starting point. The last year has seen a steady flow of announcements of equipment orders for the first ships of the class. LMC’s CMS 330 combat management system – used, inter alia, in the existing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halifax")]), _vm._v(" class frigates’ modernisation – will interface with an Aegis module and the new AN/SPY-7 active phased array to control three layers of protective missile systems. These will encompass Standard missiles for area defence, Evolved Sea Sparrow missiles for point defence and Sea Ceptor missiles for last-ditch, close-in protection. Other equipment, such as the Ultra Electronics bow-mounted sonar and torpedo defence systems and the Rolls-Royce supplied propulsion plant, will be largely common with the Type 26. All-in-all, the Canadian Surface Combatant will be a large and very capable ship that has inevitably resulted in significant concerns over the ultimate bill. However, the Canadian government looks committed to the programme, with orders for a first batch of three ships from an eventual fifteen-strong frigate class expected in the course of 2023 prior to the start of construction during the following year."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_4",
      "id": "fn2_4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a",
    attrs: {
      "id": "tab_2_1b"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg14_b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other shipbuilding facility heavily involved in RCN modernisation – Seaspan’s Vancouver yard – continues to work on the lead ship of two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Protecteur")]), _vm._v(" class joint support ships, which are based on the ThyssenKrupp Marine Systems (TKMS) Type 702 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Berlin")]), _vm._v(" class design.5 In March 2021 Seaspan reported that 90 percent of the vessel’s constituent blocks were in production and that the major assemblies that formed the ship’s bow section were in the course of being integrated. Delivery of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Protecteur")]), _vm._v(" is scheduled for 2023, a deadline that will be closely watched given delays with earlier ships in the NSS programme. Her sister, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Preserver")]), _vm._v(", will be delivered later in the decade as the yard has been assigned work on a new Coast Guard oceanographic science vessel between the two ships. Also on the west coast, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Victoria")]), _vm._v(" class submarine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Corner Brook")]), _vm._v(" will soon return to service for the first time since sustaining significant damage in a grounding in 2011. Her subsequent repair and refit – undertaken as part of a scheduled extended docking work period from 2014 onwards – has been delayed both by a fire and accidental damage to the boat’s ballast system; the latest "), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("in a series of mishaps to impact the class. Nevertheless, the completion of the work holds out the prospect of three of the four-boat class being available for operations in the near future; a noteworthy achievement given past problems.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Current fleet strength, unchanged year-to-year, is set out in ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1b"
    }
  }, [_vm._v("Table 2.1.2")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "ch-sub"
  }, [_vm._v("MAJOR NORTH AMERICAN NAVIES – UNITED STATES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The US Navy had a total ‘battleforce’ of 297 warships as of mid-2021. In spite of the stated aim of increasing the fleet’s size, this actually represented a small decrease year-on-year. The loss of the amphibious assault ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bonhomme Richard")]), _vm._v(" (LHD-6) to fire exacerbated the impact of planned withdrawals whilst deliveries were lower than expected as no new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom")]), _vm._v(" (LCS-1) variant Littoral Combat Ships were accepted into service following the emergence of the combining gearing problems referenced above. The situation is not likely to improve significantly over the short term. The new administration looks set to continue plans to retire many of the remaining "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ticonderoga")]), _vm._v(" (CG-47) class cruisers which – when coupled with premature retirements of Littoral Combat Ships – will counterbalance the beneficial impact of scheduled new ships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this moment, it is difficult to ascertain precisely what the longer-term future holds. The US Navy’s 2016 FSA target of 355 manned warships was initially due to be replaced by a new plan informed by a study known as the Integrated Naval Force Structure Assessment (INFSA). This also incorporated US Marine Corps (USMC) structural requirements. However, publication of the INFSA’s findings was apparently cancelled by the US Department of Defense around the end of 2019 due to discontent with the navy’s conclusions. This resulted in INFSA being superseded by a new Future Naval Force Study (FNFS) led by the Office of the Secretary of Defense. Key conclusions from the FNFS were released as part of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Report to Congress on the Annual Long-Range")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Plan for Construction of Naval Vessels")]), _vm._v(" during the dying days of the Trump administration in December 2020. This also contained the structure of an indicative 2045 fleet sometimes referred to as the ‘Battle Force 2045’ plan. ‘Battle Force 2045’ has, in turn, been superseded by a far less ambitious series of new ‘potential naval platform ranges’ released by the new Biden administration in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Report to Congress on the")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Annual Long-Range Plan for Construction of Naval")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vessels for Fiscal Year 2022")]), _vm._v(" released in June 2021. These will be refined into more specific plans over the next year. A summary of this complex and constantly evolving picture is provided in "), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1c"
    }
  }, [_vm._v("Table 2.1.3")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a",
    attrs: {
      "id": "tab_2_1c"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg15_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1c"
    }
  }, [_vm._v("1")])]), _vm._v(". Excludes one "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumwalt")]), _vm._v(" (DDG–1000) class destroyer that has been commissioned but is not yet counted as part of the ‘battle force’.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1c"
    }
  }, [_vm._v("2")])]), _vm._v(". Includes eight MCMVs.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1c"
    }
  }, [_vm._v("3")])]), _vm._v(". Split between large and small amphibious ships not stated.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1c"
    }
  }, [_vm._v("4")])]), _vm._v(". Light aircraft carriers may be included in the force mix.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taking a critical perspective, it is possible to argue that the vast variations in the numbers contained in these structure plans over such a short period of time suggests that the United States has not yet properly worked out what fleet it needs to respond to the emerging Chinse and Russian challenge. Whilst there may be some truth in such a criticism, some continuing themes are already evident. These include a likely decline in the relative importance assigned to manned surface combatants when considering both small and large vessels together; an increase in the value attached to submarines; and a very considerable future reliance on unmanned technologies. There will also have to be a substantial uplift in the logistical support force to sustain more widely dispersed units operating under a distributed maritime operations construct. The aircraft carrier looks set to remain an important part of the fleet, albeit with debate continuing over the merits of smaller carriers within the overall force structure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some additional observations seem pertinent. First, even the Biden administration’s cut-back plans suggest a significant programme of naval expansion that will require large amounts of money at a time when building the new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbia")]), _vm._v(" (SSBN-826) strategic submarines will put a severe strain on the naval budget. This suggests a tough fight for resources, potentially at the expense of other branches of the armed forces, if they are to be realised. The plans also involve a very meaningful shift in resources to new and untried technologies at the expense of tried and tested assets, as well as to the potential detriment of that part of the defence industrial base that sustains them. There will be a real struggle to achieve acceptance of this shift, a reality already demonstrated by pushback from Congress on some elements of the new plan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the time being, proposed procurement for "), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("FY2022 is largely in line with the Future Years Defence Program (FYDP) previously set out in FY2021. It encompasses eight ships: two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia")]), _vm._v(" (SSN-774) class submarines; a single "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke")]), _vm._v(" (DDG-51) destroyer; one "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Constellation")]), _vm._v(" (FFG-662) class frigate; one "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Lewis")]), _vm._v(" (T-AO-205) fleet oiler, two TATS Towing and salvage ships and a TAGOS(X) surveillance vessel at a total cost of US$18.1bn. This represents one fewer destroyer but an additional oiler and another towing ship compared with the previous FYDP’s eight-ship, US$17.8bn acquisition plan. The reduction in proposed destroyer construction – driven entirely by affordability – will impact a multi-year construction contract awarded to the class’s builders and looks set to be resisted by Congress. No FYDP information has been provided due to the uncertainties outlined above.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1d"
    }
  }, [_vm._v("Table 2.1.4")]), _vm._v(" provides a snapshot of the current US Navy fleet, with a summary of recent developments relating to major warship types set out below.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The US Navy’s future structure plans place significant emphasis on unmanned and autonomous vessels despite some Congressional scepticism as to how well these new technologies will work. This April 2021 image shows the prototype autonomous catamarans "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seahawk")]), _vm._v(" (front) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sea Hunter")]), _vm._v(" departing harbour for the Unmanned Systems Integrated Battle Problem 2 manned-unmanned teaming exercise. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Navy)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16_b.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The new US navy aircraft carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gerald R. For")]), _vm._v("d (CVN-78) is dwarfed by a huge explosion during the first of a planned series of shock trials. The force of the blast – which took place 100 miles off the Florida coast – registered the equivalent of a 3.9 magnitude earthquake. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Navy)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aircraft Carriers:")]), _vm._v(" The last year has seen the new carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gerald R. Ford")]), _vm._v(" (CVN-78) make further progress towards operational service, undertaking the first of a series of shock trials on Friday 18 June 2021. The test, which took place 100 miles off the Florida coast, registered the equivalent of a 3.9 magnitude earthquake. The last US Navy aircraft carrier to go through similar testing was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theodore Roosevelt")]), _vm._v(" (CVN-71) in the autumn of 1987. Completion of the trials will be followed by a period in dockyard hands for final defect rectification prior to the new carrier being cleared to commence work up for operational deployment. Future planned deliveries of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ford")]), _vm._v(" class carriers encompass "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John F. Kennedy")]), _vm._v(" (CVN-79) in 2024, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise")]), _vm._v(" (CVN-80) in 2028 and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Doris Miller")]), _vm._v(" (CVN-81) in 2032 under a procurement programme estimated to cost in excess of US$50bn."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_5",
      "id": "fn2_5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Surface Combatants:")]), _vm._v(" The US Navy continues to divide its surface combatants into large surface "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("combatants – cruisers and destroyers – and small surface combatants – frigates, Littoral Combat Ships (LCS), mine countermeasures vessels (MCMVs) and patrol craft. Numbers of large surface combatants have been steadily increasing in recent years following resumed procurement of Flight IIA "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke")]), _vm._v(" class destroyers from FY2010. The last year saw their numbers further increase by a further unit with delivery of the Bath Iron Works (BIW)-built "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daniel Inouye")]), _vm._v(" (DDG-118) in March 2021. This trend is expected to accelerate in the coming years as BIW and Huntington Ingalls Industries (HII) work through a backlog of orders. From around 2023, deliveries will transition to the new, improved Flight III variant incorporating the new AN/SPY-6 Air and Missile Defence Radar (AMDR) starting with effect from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jack H. Lucas")]), _vm._v(" (DDG-125). The ship was launched by HII on 11 June 2021. The third and final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumwalt")]), _vm._v(" class destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lyndon B. Johnson")]), _vm._v(" (DDG-1002) should also be completed within the next two to three years. Debate continues as to how best these ships should be outfitted for their new surface strike role given the significant amount of bespoke technology they incorporate. However, it seems that previous thoughts around installing electromagnetic railguns in the class have now been superseded with plans to equip them with launchers for new hypersonic land attack missiles.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('div', {
    staticClass: "img_container1a",
    attrs: {
      "id": "tab_2_1d"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg17_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes:")])])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', {
    staticClass: "bold"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1d"
    }
  }, [_vm._v("1")]), _vm._v(" Includes one ship commissioned but not fully operational pending completion of combat systems installation.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1d"
    }
  }, [_vm._v("2")])]), _vm._v(" Plus mission-related crew.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1d"
    }
  }, [_vm._v("3")])]), _vm._v(" Third of class, SSN-23 is longer and heavier.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1d"
    }
  }, [_vm._v("4")])]), _vm._v(" LHD-8 has many differences.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1d"
    }
  }, [_vm._v("5")])]), _vm._v(" Includes four LSD-49 HARPERS FERRY variants.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The flip side to these new arrivals is the acceleration of plans to withdraw the veteran "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ticonderoga")]), _vm._v(" class cruisers, with a total of seven now slated for decommissioning over the next fiscal year. The navy is struggling to keep what are effectively life-expired hulls in an effective state against a backdrop of increasing repair and maintenance costs. The current aim seems to be to keep just enough of the class in commission to cover the key carrier strike group air defence command role the ships undertake during carrier deployments until they can be replaced by the new Flight III "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke")]), _vm._v("s. However, each cruiser carries 122 vertical launch system (VLS) missile cells; a loss that will be severely felt as the navy attempts to boost its strike capacity."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_6",
      "id": "fn2_6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turning to smaller combatants, the last year has seen deliveries of two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independence")]), _vm._v(" (LCS-2) class variants – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mobile")]), _vm._v(" (LCS-26) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Savannah")]), _vm._v(" (LCS-28) – taking the number in service to fourteen. All but one of the remaining five members of the class are under construction following the start of work on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kingsville")]), _vm._v(" (LCS-36) at Austal’s Mobile facility on 5 January 2021. However, the lead ship – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independence")]), _vm._v(" – will be withdrawn from service later in 2021 as part of previously announced plans to "), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("dispose of the first pair of prototype ships of each LCS variant due to systems’ incompatibilities with later members of the class. This plan will also see "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom")]), _vm._v(" decommissioned over the coming months. No further members of this variant have joined the fleet since the delivery of the tenth ship – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St Louis")]), _vm._v(" (LCS-19) – in June 2020 due to the need to resolve the gear train defects previously discussed. The Fincantieri Marinette Marine yard that builds the type currently has a backlog of six members of the class at various stages of construction. It will then progress to building the new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Constellation")]), _vm._v(" class frigates. The second of these ships – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Congress")]), _vm._v(" (FFG- 63) – was ordered on 20 May 2021.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg18_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Continued deliveries of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke")]), _vm._v(" class destroyers will be counterbalanced by planned withdrawals of many of the remaining "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ticonderoga")]), _vm._v(" class cruisers, which are proving expensive to modernise and maintain. The HII-built "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delbert D. Black")]), _vm._v(" (DDG-119) was officially handed over to the US Navy on 24 April 2020 but – partly because of the pandemic – it was not until 4 September that she finally left the building yard. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Huntington Ingalls Industries)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg18_b.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom")]), _vm._v(" variant Littoral Combat Ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")]), _vm._v(" (LCS-19) pictured transiting the St. Lawrence Seaway in June 2020. The emergence of a design problem with the class’s gearing has meant that no further ships of the class have been accepted into service. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Marc Piché)")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("In spite of the delays to the LCS programme – and its associated mine warfare modules – the navy is pushing ahead with plans to withdraw its existing MCMVs. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Champion")]), _vm._v(" (MCM-4), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scout")]), _vm._v(" (MCM-8) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ardent")]), _vm._v(" (MCM-12) were all decommissioned in August 2020. This leaves eight of the original fourteen-strong "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Avenger")]), _vm._v(" (MCM-1) class in service. Somewhat below the radar screen, the navy has also been accelerating disposal of small combatants that do not appear in the official ‘battle force’ list, including the three 400-ton "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cyclone")]), _vm._v(" (PC-1) class patrol boats assigned to home waters."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_7",
      "id": "fn2_7"
    }
  }, [_vm._v("7")]), _vm._v(" They will be followed by the twelve relatively new 70-ton Mk VI fast patrol boats delivered by SAFE Boats International between 2016 and 2018 for riverine and littoral operations. The current thinking appears to utilise Coast Guard assets to replace the gap created by these withdrawals. It is believed around US$200m has been spent acquiring and supporting the Mk VI boats in recent years; an investment that will now effectively be written off in another example of muddled US Navy procurement planning."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_8",
      "id": "fn2_8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Acquisition of the new generation of unmanned surface vessels that will supplement the manned fleet is still in the embryonic stage. The navy eventually hopes to field both missile-armed large unmanned surface vehicles (LUSVs) and sensor-carrying medium unmanned surface vehicles (MUSVs) but is being forced to move ahead slowly in the face of Congressional scepticism. In July 2020 a team led by L3Harris was awarded a US$35m contract for the design and construction of a MUSV prototype that "), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("could eventually result in the exercise of options for a further eight vessels. Subsequently, in September 2020, six contracts worth US$7m each were agreed with Austal USA, Bollinger Shipyards, Gibbs & Cox, HII, Lockheed Martin & Marinette Marine to produce design concepts for the LSUV. This should lead to the procurement of a prototype vessel during FY2022 and deployable ships from FY2023 onwards. In the meantime, testing of existing unmanned concept vessels in conjunction with manned warships is being stepped up by the US Navy’s Surface Development Squadron 1, which was stood up at San Diego in May 2019. The squadron is slowly expanding, most recently taking delivery of a second autonomous "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sea Hunter")]), _vm._v(" type catamaran, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seahawk")]), _vm._v(", in April 2021. Later that month, the two ships played an important role alongside manned squadron member "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael Monsoor")]), _vm._v(" (DDG-1001) and other unmanned and manned assets in Unmanned Systems Integrated Battle Problem 2, an early trial of the manned-unmanned teaming approach that will be fundamental to the DMO concept.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg19_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A team led by L3Harris has been awarded a contract for the design and construction of a prototype of the sensor-carrying medium unmanned surface vehicles (MUSVs) that are destined to play a major part in future US Navy operations. This is a graphic of the ship’s design. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(L3Harris)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg19_b.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The amphibious assault ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bonhomme Richard")]), _vm._v(" (LHD-6) seen during the evening of 12 July 2020, several hours after a blaze broke out aboard the vessel. It took some four days to extinguish the fire and the damage was so great that it was decided to decommission and scrap the newly-refitted ship. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Navy)")])])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Amphibious and Support Shipping:")]), _vm._v(" The US Navy’s amphibious fleet suffered a major loss in July 2020 when the newly-refitted amphibious assault ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bonhomme Richard")]), _vm._v(" was destroyed by fire. The conflagration broke out after an explosion whilst the ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("ship was alongside at San Diego in the morning of 12 July 2020 and had damaged eleven of the ship’s fourteen deck levels by the time it was extinguished some four days later. Analysis of the cause of the blaze and its rapid spread remain under investigation amidst speculation that arson might have been involved. However, the fact the ship had still to be fully restored to operational condition after her recent upgrade was likely an exacerbating factor. The cost of repairing the 22-year-old ship – some US$2.5bn to US$3.2bn – was deemed to be prohibitively expensive. Accordingly, she departed on her final voyage to the scrapyard in mid-April 2021.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg20_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The first "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Lewis")]), _vm._v(" (T-AO-205) class fleet replenishment oiler was launched from the General Dynamics NASSCO yard on 12 January 2021. This photograph was taken shortly before the ship’s launch. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(General Dynamics NASSCO)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There have been no deliveries of major amphibious vessels in the last year, although "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tripoli")]), _vm._v(" (LHA-7) was commissioned on 15 July 2020 after having been delivered the previous February. Conversely, a start has been made on withdrawing the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Whidbey Island")]), _vm._v(" (LSD-41) dock landing ships with the departure of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort McHenry")]), _vm._v(" (LSD-43) from the fleet in March 2021. Whilst the initial Batch 2 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Antonio")]), _vm._v(" (LPD-17) class amphibious transport docks that are intended to replace the LSD-41 type have already been ordered, this new class could well be truncated if force structure plans that suggest fewer large amphibious ships will be required in future hold good. Their place will be taken by larger numbers of the new light amphibious warship (LAW), which are intended to support the USMC’s new Expeditionary Advanced Base Operations (EABO) strategy. These will seemingly fall somewhere between the traditional large amphibious ships and auxiliary vessels like the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spearhead")]), _vm._v(" (T-EPF-1) expeditionary fast transports in terms of size and capability. Twelve of the latter are now in service following delivery of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Newport")]), _vm._v(" (T-EPF-12) in September 2020. Another three have been ordered following the award of a contract for the future TEPF- 15 in February 2021. There had previously been some doubt over her future following the Trump administration’s decision to shift funds authorised for her build to help pay for the Mexican border wall. However, Congress added the necessary money to FY2021’s defence budget authorisation to ensure her construction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("January 2021 saw the launch from General Dynamics NASSCO of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Lewis")]), _vm._v(" (T-AO-205), the lead ship of a new class of fleet replenishment oiler. Six of the ships have been ordered to date and a seventh is included in the FY2022 budget request. The 2016 FSA envisaged a requirement for twenty of the ships but, as for so much of the US Navy’s shipbuilding programme, this is up in the air pending the Biden administration’s decisions on future fleet structure. What does seem likely is that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Lewis")]), _vm._v(" class will increasingly be supplemented by a new next-generation logistic ship (NGLS). In similar fashion to the proposed LAW, this will be a smaller and cheaper vessel that will be built in the numbers required to support a more distributed force.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Submarines:")]), _vm._v(" The need to stabilise and then rebuild the number of nuclear-powered attack submarines whilst embarking on production of the next-generation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbia")]), _vm._v(" class strategic submarines is one of the US Navy’s greatest challenges. The main problem is that the industrial base required to ramp up production was severely eroded in the aftermath of the Cold War, with production limited to just one attack submarine each year as late as FY2010. Future plans envisage orders for at least two attack submarines and one strategic submarine p.a. from the middle of the decade; a major expansion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Submarine manufacturing yards General Dynamics Electric Boat at Groton CT and HII Newport News are doing what they can to rise to the challenge. However, the overall result is proving to be something of a mixed success. On the downside, a previously enviable record of producing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia")]), _vm._v(" class attack submarines on time and to budget is starting to slip, with delivery dates continuously exceeding scheduled deadlines that have been made significantly shorter than when construction of the class first began. The impact of the COVID-19 pandemic has had a further negative impact and no "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia")]), _vm._v("s were actually delivered in the last twelve months. This resulted in the submarine force falling by two boats as at mid-2021 due to continued retirements of the life-expired members of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles")]), _vm._v(" (SSN-688) class. The navy is planning to extend the lives of six of these boats – including a refuelling of their nuclear reactors – to squeeze, perhaps, an additional ten years of service out of each hull as part of efforts to retain overall submarine numbers around existing levels. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cheyenne")]), _vm._v(" (SSN-773) will be the first of the class to embark on this programme at the start of 2022.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("In spite of production delays, it does seem that the submarine manufacturers have broadly managed to achieve the step-up in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia")]), _vm._v(" class production required, with a drumbeat of two attack submarine orders each year now firmly established. This was reinforced by Congress’s decision to add a second boat to the FY2021 naval procurement budget, ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("overturning the administration’s somewhat surprising decision to request just one attack submarine for that year. In April 2021, a US$2.4bn contract modification to build the additional submarine was made to the c. US$22bn multi-year agreement that already covered nine ‘Block V’ boats previously awarded to the General Dynamics-HII consortium responsible for the class’s production. Like most of the rest of this batch of submarines, the new boat will incorporate the Virginia Payload Module that adds additional firepower to the class.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg21_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Using a transfer car system, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia")]), _vm._v(" class submarine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montana")]), _vm._v(" (SSN-794) is seen being transferred from her construction hall to a floating dry dock at HII’s Newport News Shipbuilding yard on 15 October 2020 in preparation for her launch. US Navy submarine construction is struggling to keep to schedule as production demands continue to ramp up. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Huntington Ingalls Industries)")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Total "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia")]), _vm._v(" class orders now extend to thirtyeight units (of which thirty-six had been authorised through to FY2022) and it seems that further members of the class will be approved throughout the rest of the decade. However, attention is already starting to turn to the next generation SSN(X). In contrast to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia")]), _vm._v(" class, which was designed for multi-mission dominance in the littoral, SSN(X) will be designed for greater transit speed under increased stealth conditions in all ocean environments, and carry a larger inventory of weapons and diverse payloads. It will also be equipped to counter the threat posed by unmanned underwater vehicles (UUVs) and be able to coordinate a larger contingent of off-hull vehicles, sensors and friendly forces."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_9",
      "id": "fn2_9"
    }
  }, [_vm._v("9")]), _vm._v(" The US Navy awaits delivery of its own prototype ‘Orca’ extra-large unmanned undersea vehicles (XLUUVs), five of which were ordered from Boeing in 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, a major step forward with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbia")]), _vm._v(" strategic submarine class production was taken in November 2020 when General Dynamics Electric Boat was awarded a US$9.5bn contract for the detailed design and construction of the first two members of the twelve-boat class. Work is already underway on the four constituent models of the lead submarine allocated to Electric Boat – another two are assigned to HII – at the company’s Rhode Island complex. They will ultimately be transferred by barge to a final test and assembly yard in Groton, where the components will be assembled into a complete submarine in a 200,000ft"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")]), _vm._v(" facility currently under construction. Delivery is scheduled by the end of 2027, a tight deadline that will doubtless cause both navy and contractor many sleepless nights in the years ahead. The second submarine – named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wisconsin")]), _vm._v(" (SSBN-827) – will follow around three years later, with subsequent boats scheduled to be delivered at annual intervals thereafter. Consistently described as the US Navy’s ‘top priority program’, estimated completion of the twelve boats remains set at c. US$10bn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Operational Highlights:")]), _vm._v(" The ‘operational context’ overview provided in the press briefing that accompanied the US Navy’s FY2022 budget request suggests that the fleet remains heavily committed, with 110 ships of the then 294 ship total expected to be deployed as at the end of FY2021. The Pacific Ocean continues to be the top area of operational focus, with 51 ships operating in the region and a further 110 based on the Pacific coast. Efforts are already underway to start testing out the new operational doctrines that would be employed in any new Pacific War, including the evolving USMC’s EABO concept. This envisages small, highly-mobile and dispersed combat units penetrating an opponent’s outer defences to land on the numerous islands and atolls that proliferate across the region. These would be used as bases to conduct quick, coup-de-main type strikes on enemy forces before rapid relocation to avoid counter-attack. A major early test of this scenario was conducted during Exercise Noble Fury in October 2020, when a unit from the US 2nd Marine Regiment simulated the capture of an airfield on the Japanese island of Ie Shima. This was then used to fly in a rocket artillery battery which performed an anti-shipping strike mission before immediately departing to another location. A further series of exercises – expanded to include regional allies – is planned for the coming year."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_10",
      "id": "fn2_10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A key element of US Navy activity in recent years has been an expansion in the freedom of navigation operations – commonly abbreviated as FONOPS – aimed largely at countering the maritime claims of revisionist powers. Those in the South China Sea have garnered most attention but recent deployments in waters neighbouring Russia – whilst not a formal part of the FONOPS programme – can be viewed as forming part of the same strategy. Interestingly, the FONOPS programme has also been aimed at perceived ‘excessive claims’ by a number of allied or friendly nations, including Brazil and Japan. In April 2021, this resulted in a minor spat with India when the destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Paul Jones")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v(" (DDG-53) sailed west of Lakshadweep Islands, which are within India’s exclusive economic zone."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_11",
      "id": "fn2_11"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the United States is attempting to deemphasise its footprint in the Middle East, tensions between the US Navy and Iranian forces in the region remain high. A number of incidents have occurred during which Islamic Revolutionary Guard Corps (IRGC) boats have harassed US Navy and US Coast Guard vessels operating in the Persian Gulf, resulting in the firing of warning shots on more than one occasion. There is a clear danger that any reduced American presence resulting from the Global Posture Review will encourage such action with potentially dangerous consequences. The refocusing of US Navy forces is also making its presence in South America. Here the USMC’s Special Purpose Marine Air-Ground Task Force–Southern Command – used to support local allies in training, internal security and humanitarian operations – is being shut down as the Corps looks to concentrate on its new Pacific mission. It has to be questioned whether the saving – reportedly just US$3m – is worth the likely loss of influence in the United States’ own back yard.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg22_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A F-35B Lightning II strike fighter from Marine Fighter Attack Squadron 121 (VMFA-121) the ‘Green Knights’ refuels at an established Forward Arming and Refuelling Point during simulated Expeditionary Advanced Base Operations (EABO) in March 2019. The new concept is seen as an essential part of any future warfighting in the Pacific. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Marine Corps)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("US Coast Guard:")]), _vm._v(" The US Coast Guard’s fleet renewal plan has continued to make progress over the past year. The plan, which dates back as far as 2004, envisages the replacement of existing ships with a fleet of eight large oceanic national security cutters, twenty-five intermediate sized offshore patrol cutters and fifty-eight coastal fast response cutters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The large ships are the ‘Legend’ or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bertholf")]), _vm._v(" (WMSL-750) class. Due to Congressional largesse, eleven of this type have actually been ordered to date and nine are now in service following the commissioning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stone")]), _vm._v(" (WMSL-758) on 19 March 2021. HII’s Ingalls division has built all the class, commencing fabrication of the final vessel – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Friedman")]), _vm._v(" (WMSL-761) – in May 2021. They replace the twelve 1960s-era "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamilton")]), _vm._v(" (WHEC- 715) high endurance cutters, which have all now been withdrawn from service following the decommissioning of the final member of the class, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Douglas")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Munr")]), _vm._v("o (WHEC-724), on 24 April 2021.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only slightly smaller and less capable ‘Legend’ class offshore patrol cutters will replace twenty-nine medium endurance cutters. Construction of the four initial members of the class has been allocated to Eastern Shipbuilding in Panama City Florida and the final vessel of this batch is included within the US Coast Guard’s FY2022 budget request. The company was originally due to build more of the ships but an open competition is currently underway for the next eleven vessels after the shipyard ran into difficulties following damage from Hurricane Michael in December 2018. Meanwhile Congress funded the final four ‘Sentinel’ class fast response cutters in the FY2021 budget, taking total authorisations to the fifty-eight vessels in the renewal plan plus an additional six for service in the Persian Gulf. The craft are being built to Damen’s Stan Patrol 4708 design by Bollinger Shipyards, which had delivered forty-five of the type by mid-2021.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other major Coast Guard procurement programme is for new Polar Security Cutters. Two of a planned three heavy icebreakers have been funded to date and should be followed by three medium icebreakers in due course. The first of the new vessels should start construction at VT Halter Marine before the end of 2021 for delivery in 2024. The urgent requirement for the new ships was demonstrated by a propulsion train fire aboard the existing medium icebreaker "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Healy")]), _vm._v(" (WAGB-20) – one of only two operational Coast Guard icebreakers – in August 2020, severely limiting the service’s ability to conduct polar operations until complex repairs could be effected.")]), _vm._v(" "), _c('h3', {
    staticClass: "ch-sub"
  }, [_vm._v("OTHER NORTH AND CENTRAL AMERICAN NAVIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mexico’s")]), _vm._v(" navy remains the only maritime force of note in the rest of North and Central America its modernisation has essentially ground to a halt under the current Obrador administration. The existing 2019–24 procurement programme envisages the acquisition of as many as thirty-six new vessels for the navy in Mexican yards. These include two additional ‘POLA’ (Damen ‘Sigma’ 10514) corvette-like oceanic patrol vessels and four "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tenochtitlan")]), _vm._v(" class (Damen Stan Patrol 4207) inshore patrol vessels. However, funding has not been provided to progress construction of anything more than six small seaweed collection boats against a backdrop of official disapproval of the navy’s partnership with foreign private enterprise to progress new projects. The only bright spot has been the delivery of the eighth and final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oaxaca")]), _vm._v(" class OPV. The new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tabasco")]), _vm._v(" was commissioned on 1 June 2021."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_12",
      "id": "fn2_12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Turning to Central America and the Caribbean, the most significant news is possibly the pending arrival of two new 58m Austal ‘Cape’ class patrol boats for the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Trinidad and Tobago")]), _vm._v(" Coast Guard. The new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Port of Spain")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scarborough")]), _vm._v(" were handed over at Austal’s Henderson facility in May 2021 prior to departure for the long voyage to their new home aboard a heavy lift ship in June. Other new arrivals include the first examples of a series of ‘Near Coastal Patrol Vessels’ being supplied to countries across the region as part of a US Department of Defense initiative to strengthen regional security. The first of these vessels – Metal Shark 85 ‘Defiant’ type boats based on Damen’s Stan Patrol 2606 hull form – was incorporated into the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Dominican Republic’s")]), _vm._v(" navy as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Betelgeuse")]), _vm._v(" at the Las Calderas Navy Base on 6 August 2020. Up to thirteen are scheduled for delivery to partner nations in the region, with "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("El Salvador")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Guatemala")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Honduras")]), _vm._v(" amongst other nations due to receive examples of the type. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Costa Rica")]), _vm._v(" has also been receiving Metal Shark boats, with smaller ‘Defiant 45’ and ‘Defiant 38’ craft reportedly delivered at the end of 2020.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('h3', {
    staticClass: "ch-sub"
  }, [_vm._v("MAJOR SOUTH AMERICAN NAVIES - BRAZIL")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Brazil is currently the only Latin American country with active programmes for the construction of front-line naval combatants."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_13",
      "id": "fn2_13"
    }
  }, [_vm._v("13")]), _vm._v(" Major projects for the delivery of new submarines and frigates are in progress but both are seemingly being impacted by the severity of the COVID-19 pandemic that continues to hold Brazil in its grip. Reports suggest that this is affecting both the ability of industry to maintain design and construction activity and also the funding required to pay for the programmes that are underway.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg23_a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg23_b.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The first Brazilian ‘Scorpène’ type submarine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riachuelo")]), _vm._v(" has spent much of the last year undergoing trials from the giant submarine manufacturing complex and operating base at Itaguaí. She is expected to commission around the end of 2021 and will subsequently be followed by three further boats. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Naval Group)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The giant PROSUB construction project has made some headway in the last year. In July 2020, the Brazilian Navy formally inaugurated its new submarine base at Itaguaí – part of a wider submarine construction and maintenance complex – that will be home for the four ‘Scorpène’ type boats being completed under the programme. However, the lead submarine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riachuelo’")]), _vm._v("s programme of tests and sea trials could well have been impacted by an accident in March 2021 that caused salt water flooding of her bow area. Current reports suggest that her delivery is now scheduled for the end of 2021, a further shift to the right. Her sister, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Humaitá")]), _vm._v(", was launched on 11 December 2020 and the hull of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tonelero")]), _vm._v(", the "), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("third of the quartet, closed up on the same day. Their deliveries are now scheduled to take place early in 2023 and 2025, with the final boat – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Angostura")]), _vm._v(" – bringing up the rear in 2025. The preliminary design of the planned follow-on nuclear attack submarine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alvaro Alberto")]), _vm._v(" was reportedly completed at the end of 2020, paving the way for the award of initial construction contracts. However, even if all goes well – by no means a certainty given previous delays – it will not be before the mid-2030s that she becomes operational.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('div', {
    staticClass: "img_container1a",
    attrs: {
      "id": "tab_2_1e"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg24_a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The vast sums being allocated to submarine construction are squeezing other naval programmes. However, conclusion of contracts early in 2020 with the TKMS/Embraer-controlled Águas Azuis consortium for a quartet of new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tamandaré")]), _vm._v(" class MEKO type frigates does hold out the prospect of at least partial renewal of Brazil’s aging surface fleet. A number of contracts for long-lead items for the ships have subsequently been confirmed over the past year but actual construction of the first ship is not expected to commence before 2022. This suggests anticipated delivery in 2025 – already pushed back a year – may prove optimistic. The only other significant warship deliveries expected before then are the two final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Macaé")]), _vm._v(" class OPVs "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maracanã")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mangaratiba")]), _vm._v(", the third and fourth members of what was initially planned to be a numerous type. The ships are being completed at Rio de Janeiro Navy Arsenal following the financial collapse of the EISA shipyard initially tasked with their construction.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Current Brazilian fleet strength – unchanged yearon-year – is set out in ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#tab_2_1e"
    }
  }, [_vm._v("Table 2.1.5")]), _vm._v(". Away from the headline numbers, the major departure was the MCMV "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Albardão")]), _vm._v(", which was decommissioned in May 2021. This leaves just three minehunters in operational service.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg24_b.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Chile’s ASMAR is expected to commence construction of four new amphibious and military transport vessels based on a VARD 7 series concept once work on a new icebreaker has been completed. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(VARD)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "ch-sub"
  }, [_vm._v("OTHER SOUTH AMERICAN NAVIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Elsewhere in South America, current projects are largely focused on improving constabulary and maritime logistical support capabilities. Although a number of the region’s navies have ambitions for replacement frigate and submarine construction – the former often having a local element – these are unlikely to gain traction in the current environment considering the ongoing social and economic devastation being caused by the pandemic."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#2fn_14",
      "id": "fn2_14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chile")]), _vm._v(" continues to have the region’s most up-todate and effective combat force. The last year has seen it continue modernising its existing trio of Type 23 frigates on the basis of a project built around LMC’s CMS 330 combat management system. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Almirante Lynch")]), _vm._v(" (the former HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grafton")]), _vm._v(") has now finished the upgrade at ASMAR’s Talcahuano yard, leaving only "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Almirante Condell")]), _vm._v(" (formerly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marlborough")]), _vm._v(") to complete the programme. The navy envisages maintaining a fleet of eight surface combatants and might look to acquire one of the additional British Royal Navy Type 23 frigates slated for withdrawal under the latest defence review to replace its elderly Type 22 frigate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Almirante Williams")]), _vm._v(" (previously "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sheffield")]), _vm._v("). The two FFG-7 class frigates acquired from Australia in 2019 and a pair of former Dutch ‘M’ class frigates make up the rest of the flotilla.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The longer-term aim is to build new frigates at ASMAR but the company is currently fully occupied with completing the ‘VARD 9-203’ type icebreaker "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Antártica 1")]), _vm._v(", now scheduled for delivery in 2023. It "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("will then commence work on a quartet of LSD-like amphibious and military transport vessels, which will be based on a VARD 7 series concept under a contract awarded in February 2021. These will eventually replace the two existing ‘BATRAL’ type tank landing ships, the transport "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aquiles")]), _vm._v(" and the amphibious transport dock "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sargento Aldea")]), _vm._v(" (the former French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Foudre")]), _vm._v("). The navy also needs to replace the elder pair – comprising two Type 209/1400 Simpson class boats – of its four-strong underwater flotilla but there has been no recent news of developments in this regard.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In spite of the first arrivals of the new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bouchard")]), _vm._v(" class OPVs, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Argentina’s")]), _vm._v(" navy remains in rather desperate straits. Its two remaining submarines are inoperable and – with the apparent cancellation of the refit of the more modern "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Cruz")]), _vm._v(" – it seems unlikely that either will ever go to sea again. In March 2021, a number of former high ranking Argentine officers were subject to sentences varying from close arrest to dismissal from the service for acts of omission with respect to the loss of her sister, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Juan")]), _vm._v(", in November 2017. Meanwhile immediate naval priorities appear to encompass completion of two 36m cadet training ships by the local Astillero Rio Santiago yard as a precursor to other indigenous construction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Colombia’s")]), _vm._v(" COCTEMAR and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Peru’s")]), _vm._v(" SIMA both continue to build new second-line but effective ships to their respective navies. The former delivered the sixth ‘BDA/BAL-C’ logistic support landing ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bahía Solano")]), _vm._v(" in March 2021 and hopes to receive orders for new OPVs to its improved OPV-93C design under the Naval Development Plan 2042 that was published in mid-2020. The Colombian Navy was also bolstered by the delivery of another former South Korean corvette – the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Po Hang")]), _vm._v(" type "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Almirante Tono")]), _vm._v(" (previously "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Iksan")]), _vm._v("). SIMA completed the fifth and sixth "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Río Pativilca")]), _vm._v(" coastal patrol ships "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Río Tumbes")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Río Locumba")]), _vm._v(" early in 2021 and is scheduled to be involved in a new OPV construction programme for up to three vessels once the Callao shipyard has finished work on the second "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paita")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Makassar")]), _vm._v(") class amphibious transport dock "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pisco")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other South American countries with active patrol vessel programmes include "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ecuador")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Uruguay")]), _vm._v(". The former received two former South Korean Coast Guard "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hae Uri")]), _vm._v(" class coastal patrol vessels at the end of 2020 and its own local shipbuilding group is building what could be the first of a series of German Fassmer MPV70 Mk III multirole vessels. For its part, Uruguay has negotiated the transfer of three comparatively modern ‘Marine Defender’ (Stan Patrol 2600 series) coastal patrol vessels from the US Coast Guard as it continues to seek to progress its longstanding requirement for upto-date offshore patrol vessels.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes")])])]), _c('p', {
    staticClass: "notes1"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', {
    staticClass: "bold"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_1",
      "id": "2fn_1"
    }
  }, [_vm._v("1")]), _vm._v(". These figures are taken from the budget briefing materials released by the Office of the Undersecretary of Defense (Comptroller) and available at: comptroller.defense.gov/Budget-Materials/. In inflation adjusted, constant FY2010 terms the FY2022 naval budget request was US$170.3bn compared with US$171.6bn last year, a recent high of US$177.5bn in FY2020 and US$177.1bn in 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_2",
      "id": "2fn_2"
    }
  }, [_vm._v("2")])]), _vm._v(". See: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Advantage at Sea – Prevailing with Integrated All-Domain Naval Power")]), _vm._v(" published jointly by the US Navy, the US Marine Corps and the US Coast Guard in December 2020.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_3",
      "id": "2fn_3"
    }
  }, [_vm._v("3")])]), _vm._v(". Further analysis on the recent development of the US Navy’s future force structure is contained later in this chapter. A more detailed assessment can be found in Ronald O’ Rourke’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Force Structure and Shipbuilding Plans: Background and Issues for Congress RL32665")]), _vm._v(" (Washington DC: Congressional Research Service, 2021). Like many of Mr O’Rourke’s other periodically updated reports, this has been posted as a public service on the Federation of American Scientists’ website at: fas.org/sgp/crs/weapons/")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_4",
      "id": "2fn_4"
    }
  }, [_vm._v("4")])]), _vm._v(". See David Pugliese’s ‘Government to commit to building first three warships despite budget concerns’ posted to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ottawa Citizen")]), _vm._v(" website – ottawacitizen.com – on 8 June 2021.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_5",
      "id": "2fn_5"
    }
  }, [_vm._v("5")])]), _vm._v(". See Ronald O’ Rourke, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Ford (CVN-78) Class Aircraft Carrier Program: Background and Issues for Congress RS2064")]), _vm._v(" (Washington DC: Congressional Research Service, 2021), p.10.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_6",
      "id": "2fn_6"
    }
  }, [_vm._v("6")])]), _vm._v(". An excellent overview of the different considerations impacting withdrawals of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ticonderoga")]), _vm._v(" class was provided by Megan Eckstein, ‘Navy “Struggling” to Modernize Aging Cruiser Fleet As Tight Budgets Push Pentagon to Shed Legacy Platforms’ posted to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USNI News")]), _vm._v(" site – news.usni.org on 5 April 2021.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_7",
      "id": "2fn_7"
    }
  }, [_vm._v("7")])]), _vm._v(". A further ten members of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cyclone")]), _vm._v(" class currently operate in the Persian Gulf. They are also drawing towards the end of their service life.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_8",
      "id": "2fn_8"
    }
  }, [_vm._v("8")])]), _vm._v(". A strong critique of the decision to retire the Mk VI patrol boats was provided by Christopher P Cavas in ‘A Problem of Commitment’ posted to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Defense & Aerospace Repo")]), _vm._v("rt site – defaeroreport.com – on 11 April 2021. Comparing the proposed light amphibious warship (LAW) to the Mk VI debacle, he wrote: ‘The LAW, in other words, is the next shiny object, the latest infatuation, in a line of ship types leading back in time from the Mark VIs to the littoral combat ship to the patrol coastals … But if repeated examples of recent history are any guide, the next generation of Navy and Marine officers and planners with their own priorities and viewpoints are very likely to urge the craft be discarded, probably even before the initial group is in service.’")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_9",
      "id": "2fn_9"
    }
  }, [_vm._v("9")])]), _vm._v(". For additional information on the evolving SSN(X) development effort see another Ronald O’Rourke report, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Next-Generation Attack Submarine (SSN[X]) Program: Background and Issues for Congress IFF 11826")]), _vm._v(" (Washington DC: Congressional Research Service, 2021).")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_10",
      "id": "2fn_10"
    }
  }, [_vm._v("10")])]), _vm._v(". For more information on the USMC’s efforts to adapt to the EABO concept see Sidney E. Dean, ‘A Renaissance in Amphibious Warfare’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maritime Security & Defence")]), _vm._v(" – June 2021 (Bonn: Mittler Report, 2021), pp.53–7.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_11",
      "id": "2fn_11"
    }
  }, [_vm._v("11")])]), _vm._v(". The US Department of Defense issues an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Annual Freedom of Navigation Report")]), _vm._v(", the latest located at: policy.defense.gov/Portals/11/Documents/FY20%20DoD%20FON%20Report%20FINAL.pdf. Indian ire at the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Paul Jones")]), _vm._v(" transit was reported in an article by Rezaul H. Laskar and Rahul Singh, ‘India objects to US Navy operations near Lakshadweep’ posted to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hindustan Times")]), _vm._v("’ website – hindustantimes.com – on 10 April 2021.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_12",
      "id": "2fn_12"
    }
  }, [_vm._v("12")])]), _vm._v(". Interestingly, the Mexican Navy’s responsibilities have been increased significantly over the last year in spite of its procurement woes as it has been granted responsibility for managing the country’s commercial ports and mercantile marine department. The aim, apparently, is to root out longstanding corruption.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_13",
      "id": "2fn_13"
    }
  }, [_vm._v("13")])]), _vm._v(". The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Poder Naval")]), _vm._v(" site – "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.naval.com.br/blog/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.naval.com.br/blog/")])])]), _vm._v(" – remains an essential source for detailed information on Brazilian Navy developments.")]), _vm._v(" "), _c('p', {
    staticClass: "notes2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#fn2_14",
      "id": "2fn_14"
    }
  }, [_vm._v("14")])]), _vm._v(". Along with official navy websites, the Spanishlanguage infodefensa.com and its rival defensa.com remain invaluable sources of information on naval developments in Central and South America. A good overview of the main regional navies was also provided by Tim Fish in ‘Briefing: South American naval fleets: keeping up appearances’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jane’s Defence Weekly")]), _vm._v(" – 18 November 2020 (Coulsdon: Jane’s, 2021), pp.22–7")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ad487c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter02.vue
// module id = 75
// module chunks = 0